/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  parts: ['container', 'list', 'listItem', 'listItemSx', 'heading'],
  baseStyle: {
    container: {
      color: 'white',
    },
    list: {
      fontSize: 'sm',
    },
    headingLink: {
      display: 'inline-flex',
    },
    heading: {
      fontSize: 'md',
      paddingTop: 3,
      paddingBottom: 3,
    },
  },
  variants: {
    vertical: {},
    horizontal: {
      list: {
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
      },
      listItem: {
        borderLeft: '1px solid',
        paddingLeft: 2,
      },
      listItemSx: {
        '&:first-of-type': {
          borderLeft: 0,
          paddingLeft: 0,
        },
      },
    },
  },
  defaultProps: {
    variant: 'vertical',
  },
};
